// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"2c5b89f1","769":"4493bc01"}[chunkId] + ".chunk.css";
};